import { MenuItem, Select } from "@mui/material";
import swal from "sweetalert2";
import ClickAwayListener from "react-advanced-click-away";
import SideMenu from "../Components/SideMenu";
import { Menu } from "@mui/icons-material";
import { useSpring, animated } from "@react-spring/web";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSecureData } from "../hooks/isLogged";
import WholeCard from "../Components/Card";
import Loading from "../Components/Loading";
import SearchInput from "../Components/SearchInput";
import Layout from "../Layout/layout";

export default function Home() {
  const [active, setActive] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [price, setPrice] = useState([0, 0]);
  const [properties, setProperties] = useState([]);
  const [logged, setLogged] = useState(false);
  const { data, loadData, error } = useSecureData(
    localStorage.getItem("token")
  );
  const [filter, setFilter] = useState("new");
  const [category, setCategory] = useState("all_category");
  const [lokasi, setLokasi] = useState("all_wilayah");
  const [activeButton, setActiveButton] = useState("all_category");

  const changePriceRange = async (price) => {
    setLoading(true);

    const property = properties.filter(
      (property) => property.harga >= price[0] && property.harga <= price[1]
    );
    setProperties(property);
    setLoading(false);
  };

  const changeFilter = async (fil) => {
    setLoading(true);

    let response;
    let json;
    if (lokasi !== "all_wilayah") {
      response = await fetch(
        `https://kjpp-server.vercel.app/api/properties/lokasi/${lokasi}/filter/${fil}`
      );
    } else {
      response = await fetch(
        `https://kjpp-server.vercel.app/api/properties/${category}/${fil}`
      );
    }

    if (response.ok) {
      json = await response.json();

      if (price[1] > 0) {
        const property = json.filter(
          (property) => property.harga >= price[0] && property.harga <= price[1]
        );
        setProperties(property);
      } else {
        setProperties(json);
      }
    }

    setLoading(false);
  };

  const changeLokasi = async (lokasi) => {
    setLoading(true);

    await fetch(
      `https://kjpp-server.vercel.app/api/properties/lokasi/${lokasi}/filter/${filter}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (price[1] > 0) {
          const property = data.filter(
            (property) =>
              property.harga >= price[0] && property.harga <= price[1]
          );
          setProperties(property);
        } else {
          setProperties(data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  const checkLogged = () => {
    if (data && !loadData && !error) {
      setLogged(true);
    }
  };

  useEffect(() => {
    checkLogged();
  }, [lokasi, data, error, loadData]);

  useEffect(() => {
    if (lokasi !== "all_wilayah") {
      changeLokasi(lokasi);
    } else if (category !== "all_category") {
      changeFilter(filter);
    } else if (lokasi === "all_wilayah") {
      changeLokasi("all_wilayah");
    } else {
      changeFilter(filter);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, filter, price]);

  const drawer = useSpring({
    transform: active ? "translateX(0%)" : "translateX(-100%)",
    position: "fixed",
    overflow: "auto",
    top: "0",
    bottom: "0",
    backgroundColor: "white",
    borderRight: "1px solid rgba(0,0,0,0.1)",
    height: "100vh",
    width: "256px",
    zIndex: "10",
  });

  const handleClickAway = () => {
    setActive(false);
  };

  const logout = async () => {
    setLogged(false);
    localStorage.removeItem("token");
    swal
      .fire({
        title: "Logout Success!",
        icon: "success",
        confirmButtonText: "Close",
        timer: 1000,
      })
      .then(() => {
        navigate("/");
      });
  };

  return (
    <Layout>
      <form className="fixed top-3 right-16 z-50 lg:right-1/3">
        <SearchInput setSearchActive={setSearchActive} />
      </form>

      <div className="pt-16 min-h-screen relative">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className="lg:hidden">
            <button
              data-collapse-toggle="navbar-default"
              type="button"
              className={`fixed top-3 ${
                searchActive ? "hidden" : "block"
              } right-5 z-30 items-center p-2 w-10 md:block h-10 justify-center text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200`}
              onClick={() => setActive(!active)}
            >
              <Menu />
            </button>
            <animated.div style={drawer}>
              <div className="p-4 py-16 pb-5">
                <div
                  className="block mt-5 lg:hidden w-full"
                  id="navbar-default"
                >
                  <Link
                    to={logged ? "/create" : "https://web.whatsapp.com"}
                    className="border block text-center border-primary text-primary hover:bg-primary hover:text-white px-6 py-3 rounded-md font-bold transition duration-200 text-sm hover:opacity-80"
                  >
                    {logged ? "Tambah" : "Jual"}
                  </Link>
                </div>
                <SideMenu
                  setCategory={setCategory}
                  setPriceRange={setPrice}
                  setLokasi={setLokasi}
                  changePriceRange={changePriceRange}
                  changeLokasi={changeLokasi}
                  active={activeButton}
                  setActive={setActiveButton}
                  setNavActive={setActive}
                />
                <button
                  className={`bg-primary mt-5 w-full text-white px-6 py-3 rounded-md font-bold transition duration-200 text-sm hover:opacity-80 ${
                    logged ? "block" : "hidden"
                  }`}
                  onClick={logout}
                >
                  Logout
                </button>
              </div>
            </animated.div>
          </div>
        </ClickAwayListener>

        <div
          className={`hidden h-screen lg:fixed top-0 lg:block bg-white z-10 border-r transition-transform max-w-64 overflow-auto translate-x-0 px-4 pt-14`}
        >
          <SideMenu
            setCategory={setCategory}
            setPriceRange={setPrice}
            setLokasi={setLokasi}
            changePriceRange={changePriceRange}
            changeLokasi={changeLokasi}
            active={activeButton}
            setActive={setActiveButton}
            setNavActive={setActive}
          />
        </div>

        <main className={`w-full lg:pl-[270px] p-5 relative`}>
          {loading && (
            <div className="h-screen -mt-20 w-full flex justify-center items-center">
              <Loading />
            </div>
          )}
          {!loading && (
            <div className="w-full">
              <div className="border-b py-2 block md:flex md:items-center md:justify-between">
                <h1 className="mb-2">
                  {properties && properties.length} Properti tersedia di KJPP
                </h1>
                <div className="flex items-center gap-2">
                  <h3 className="font-bold">Filter :</h3>
                  <Select
                    defaultValue={filter}
                    value={filter}
                    inputProps={{
                      name: "filter",
                      id: "uncontrolled-native",
                    }}
                    variant="standard"
                    className="my-select"
                    onChange={(e) => {
                      setFilter(e.target.value);
                      changeFilter(e.target.value);
                    }}
                  >
                    <MenuItem value={"new"}>Paling baru</MenuItem>
                    <MenuItem value={"old"}>Paling lama</MenuItem>
                    <MenuItem value={"cheap"}>Paling murah</MenuItem>
                    <MenuItem value={"expensive"}>Paling mahal</MenuItem>
                  </Select>
                </div>
              </div>

              <div className="w-full md:flex md:items-center md:justify-center ">
                {properties.length === 0 && (
                  <h1 className="mt-5 text-slate-400">Belum ada data Rumah</h1>
                )}

                <WholeCard properties={properties} logged={logged} />
              </div>
            </div>
          )}
        </main>
      </div>
    </Layout>
  );
}
